<template>
    <div>
        <form-element label="Titel" name="seminar.title"/>
        <form-element label="Beschreibung" name="seminar.description" component="redactor" :props="{options: redactorOptions}"/>
        <form-element name="seminar.mandatory" component="checkbox" :props="{label: 'Pflichtseminar'}"/>

        <div class="row">
            <form-element class="col" label="Anmeldung-Beginn" name="seminar.register_start" component="date-time-picker"/>
            <form-element class="col" label="Anmeldung-Ende" name="seminar.register_end" component="date-time-picker"/>
        </div>
    </div>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';

    export default {
        props: {
            seminar: {type: Object},
        },

        data() {
            return {
                redactorOptions: {
                    buttons: ['format', 'bold', 'italic', 'underline', 'link', 'ul', 'image', 'html'],
                },
            };
        },

        form: {
            cleanSubmit: true,

            getter() {
                let seminar = this.seminar || {
                    title: null,
                    description: "",
                    mandatory: false,
                    register_start: null,
                    register_end: null,
                };

                return {seminar};
            },

            validations: {
                seminar: {
                    title: {required},
                    description: {required},
                    register_start: {required},
                    register_end: {required},
                },
            },

            action() {
                this.$emit('saved', this.$form.seminar);
            },
        },

        methods: {
            submitForm() {
                this.$form.$submit();
            },

            setSeminar(seminar) {
                this.$form.seminar = seminar;
            },
        },
    };
</script>